import {
    ChangePasswordRequest,
    ChangeUsernameRequest,
    ConfirmRestPasswordRequest,
    CreateAccountRequest,
    CreateVendorAccountRequest,
    LoginUserRequest,
    VendorLoginUserRequest,
    RequestOTP,
    RestPasswordRequest,
    UpdateUserRequest,
    Post,
    StoryType,
  } from '../lib/types';

  import api from '../../module/api-client';
//   import {SecureStore} from './secure-store';
  import axios from 'axios';
  import moment from 'moment';
    import _ from 'lodash';
  
class AuthService {
    private maxTokenAge = 60 * 24;
    private maxRefreshTokenAge = 60 * 24 * 30 * 6;
    public api = api;
    // private store = new SecureStore();
    private store = localStorage
    private headers = {
      'content-type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*'
    };

    createVendorAccount = async (args: CreateVendorAccountRequest) => {
      const { name, website, email, description, logo, location } = args
      // create form Data
      const formData = new FormData()
      const { _id } = this.getUser();

      formData.append('userId', _id);
      formData.append('name', name);
      formData.append('website', website);
      formData.append('email', email);
      formData.append('description', description);
      formData.append('location', JSON.stringify(location))
      // formData.append('body', JSON.stringify({ userId: _id, name: name, website: website, email: email, description: description }));
      // formData.append('body', `userId=${_id}&name=${name}&website=${website}&email=${email}&description=${description}`);
      formData.append('logo', logo ? logo : '');
      // { userId: _id, name: name, website: website, email: email, description: description }

      const result = await this.api.post('/vendors/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
      });

      return result;
    };
    updateVendorAccount = async (args: CreateVendorAccountRequest) => {
      const { id, name, website, email, description, logo } = args
      // create form Data
      const formData = new FormData()
      const { _id } = this.getUser();

      formData.append('userId', _id);
      formData.append('name', name);
      formData.append('website', website);
      formData.append('email', email);
      formData.append('description', description);
      // formData.append('body', JSON.stringify({ userId: _id, name: name, website: website, email: email, description: description }));
      // formData.append('body', `userId=${_id}&name=${name}&website=${website}&email=${email}&description=${description}`);
      formData.append('logo', logo ? logo : '');
      // { userId: _id, name: name, website: website, email: email, description: description }

      const result = await this.api.patch('/vendors/'+id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
      });

      return result;
    };
    createAccount = async (args: CreateAccountRequest) => {
      const result = await this.api.post('/auth/register', args, {
        headers: this.headers,
      });
      return result;
    };
    login = async (args: LoginUserRequest) => {
      const result = await this.api.post('/auth/login', args, {
        headers: this.headers,
      })
      return result;
    };
    googleLogin = async (args: any) => {
      const result = await this.api.post('/auth/google/login', args, {
        headers: this.headers,
      })
      return result;
    };
    appleLogin = async (args: any) => {
      const result = await this.api.post('/auth/apple/login', args, {
        headers: this.headers,
      })
      return result;
    };
    vendorlogin = async (args: VendorLoginUserRequest) => {
      const result = await this.api.post(`/vendors/login`, args, {
        headers: this.headers,
      })
      return result;
    };
    logout = async () => {

        // clear
        this.setToken()
        this.setRefreshToken()
        this.setUser()

        //  clear vendors
        this.store.removeItem('vendors')
        this.store.removeItem('post')
        // const result = await this.api.post('/auth/logout', { refresh: this.getRefreshToken() }, {
        //   headers: this.headers,
        // });
        
        return true;
      };
    authUser = async () => {
      // const token = await this.store.getItem('token');
  
      const result = await this.api.get(`/users/me/`, {
        headers: this.headers,
      });
      return result;
    };
    isAuthenticated = () => {
        let now = moment( new Date (Date.now()))
        let exp = moment(new Date (this.store.getItem('tokenExpiry') || ''))

        let diff = (exp.diff(now, 'minutes') < 1) ? false : true

        return diff && this.store.getItem('isLogged') === 'true'
        
    };
    resetPassword = async (args: RestPasswordRequest) => {
      const result = await this.api.post(`/auth/reset-password`, args, {
        headers: this.headers,
      });

      return result;
    };
    comfirmResetPassword = async (args: ConfirmRestPasswordRequest) => {
      const result = await this.api.post(`/auth/confirm-reset-password`, args, {
        headers: this.headers,
      });

      return result;
    };
    newResetPassword = async (args: ConfirmRestPasswordRequest) => {
      const result = await this.api.post(`/auth/confirm-reset-password`, args, {
        headers: this.headers,
      });

      return result;
    };
    changePassword = async (args: ChangePasswordRequest) => {
      // const token = await this.store.getItem('token');
  
      const result = await this.api.post(
        `/auth/change-password/`,
        args,
        {
          headers: this.headers ,
        },
      );
  
      return result;
    };
    changeUsername = async (args: ChangeUsernameRequest) => {
      // const token = await this.store.getItem('token');
  
      const result = await this.api.patch(
        `/users/`,
        args,
        {
          // headers: {...this.headers, Authorization: `Bearer ${token}`},
          headers: this.headers,
        },
      );
  
      return result;
    };
    updateUser = async (args: UpdateUserRequest) => {

      const { data } = await this.api.get(`/users/me/`, {
        headers: this.headers,
      })

      const { profile } = data.data.user
   
      const result = await this.api.patch(`/users/profile/${profile._id}`, args, {
        headers: this.headers,
      });
  
      return result;
    };
    updateAvatar = async (args: any, id: string) => {
      const result = await axios({
        baseURL: 'https://eng-pulsar-400816.firebaseapp.com/api/v1',
        url: `/user/image/${id}`,
        method: 'post',
        data: args,
        headers: {
          'Content-Type': 'multipart/form-data; charset=utf-8;',
        },
      });
  
      return result;
    };
    updateProfileImage = async (args: any) => {

      const formData = new FormData()
      formData.append('profileImage', args)

      const result = this.api.post('/users/upload/profile-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
      });
  
      return result;
    };
    requestOTP = async ({phone, channel = 'sms'}: RequestOTP) => {
      const result = await this.api.post('/auth/otp/request', {phone, channel});
  
      return result;
    };
    verifyOTP = async (args: string, token: string) => {
      const result = await axios.get(`/auth/otp/verify/${args}`, {
        headers: {...this.headers, Authorization: `Bearer ${token}`},
      });
  
      return result;
    };
    checkUsername = async (args: string) => {
      const token = this.store.getItem('token');
  
      const result = await this.api.get(`/users/check-username/${args}`, {
        headers: {...this.headers, Authorization: `Bearer ${token}`},
      });
  
      return result;
    };
    refreshToken = async () => {
      const refreshToken = this.store.getItem('refreshToken');
  
      const result = await this.api.post(`/auth/refresh-token/`, { token: refreshToken },  {
        headers: this.headers,
      })
  
      return result;
    };

    //
    setToken = (token?: string | undefined) => {
        //
        if (token) {
            // this.api.defaults.headers.common["Authorization"] = `Bearer ${token}`
            this.store.setItem('token', token)
            this.store.setItem('tokenExpiry', JSON.stringify(moment().add(this.maxTokenAge, 'minutes')))
            this.store.setItem('isLogged', 'true')

        } else {
            // delete this.api.defaults.headers.common["Authorization"]
            this.store.removeItem('token')
            this.store.removeItem('tokenExpiry')
            this.store.removeItem('isLogged')
        }
        
    };
    setRefreshToken(refreshToken?: string | undefined) {
        if (refreshToken) {
            this.store.setItem('refreshToken', refreshToken)
            this.store.setItem('refresTokenExpiry', JSON.stringify(moment().add((this.maxRefreshTokenAge ), 'minutes')))
        } else {
            this.store.removeItem('refreshToken')
            this.store.removeItem('refresTokenExpiry')
        }
        
    };
    setUser = (user?: object | undefined) => {
        this.store.setItem('user', JSON.stringify(user))
    };
    setVendor = (vendor: CreateVendorAccountRequest) => {
        const vendors = this.getVendor()
        if (_.isEmpty(vendors)) {
          this.store.setItem('vendors', JSON.stringify([vendor]))
        } else {

          if (vendors.find((v: CreateVendorAccountRequest) => v.name !== vendor.name )) {
            // add vendor to vendorlist
            vendors.push(vendor);
            this.store.setItem('vendors', JSON.stringify(vendors))
          } else {
            // update vendor details
            vendors[vendors.findIndex((v: CreateVendorAccountRequest) => v.name === vendor.name)] = vendor
            this.store.setItem('vendors', JSON.stringify(vendors))
          }
        }
    };
    setPostCache = (resp: { total:number, page: number, pages: number, limit: number, data: any }) => {
      //
      const { page, data } = resp
      const cache = this.getPostCache()

      // limit cache to 
      if (_.isEmpty(cache)) {
        
        // console.log('over')
        //
        this.store.setItem('post', JSON.stringify(resp))

      } else {

        // check for new 
        if (cache.data[0].id !== data[0].id  && page === 1) {
          // console.log('there')
          //
          this.store.setItem('post', JSON.stringify(resp))

        }

        // check size
        else if (cache.data.length < 24 && page > 1) {
          // console.log('here')
          //
          const not_cached = data.filter( (d: { id: any}) => !cache.data.map((x: { id: any; }) =>x.id).includes(d.id) )

          if(not_cached.length > 0) {
            //
            // const old = cache.data
            cache.page = page
            cache.data = data

            this.store.setItem('post', JSON.stringify(cache))
          }
        
        }
        
      }
      
    };
    setStoryCache = (resp: { total:number, page: number, pages: number, limit: number, data: any }) => {
      //
      const { page, data } = resp
      const cache = this.getStoryCache()

      // limit cache to 
      if (_.isEmpty(cache)) {
        
        // console.log('over')
        //
        this.store.setItem('story', JSON.stringify(resp))

      } else {

        // check for new 
        if (cache.data[0].id !== data[0].id  && page === 1) {
          // console.log('there')
          //
          this.store.setItem('story', JSON.stringify(resp))

        }

        // check size
        else if (cache.data.length < 24 && page > 1) {
          // console.log('here')
          //
          const not_cached = data.filter( (d: { id: any}) => !cache.data.map((x: { id: any; }) =>x.id).includes(d.id) )

          if(not_cached.length > 0) {
            //
            // const old = cache.data
            cache.page = page
            cache.data = data

            this.store.setItem('story', JSON.stringify(cache))
          }
        
        }
        
      }
      
    };
    checkPostCached = (data: Post[]) => {
      //
      const cache = this.getPostCache()

      if (_.isEmpty(cache)) {
        return false
      }
          
      //
      // const _cached = cache.data.map((x: { id: any; }) => x.id).filter( (id: number | undefined) => data.map(x =>x.id).includes(id) )
      const _cached = data.map((x: { id?: any; }) => x.id).filter( (id: number | undefined) => cache.data.map((x: { id: any; }) =>x.id).includes(id) )

      if(_cached.length > 0 && _cached.length === data.length) {
        //
        return true
      }
      
      return false
      
    };

    clearPostCached = () => {
      //
      const cache = this.getPostCache()

      if (_.isEmpty(cache)) {
        return false
      } else {
        //
        this.store.setItem('post', JSON.stringify({}))
      }
    };
    checkStoryCached = (data: StoryType[]) => {
      //
      const cache = this.getStoryCache()

      if (_.isEmpty(cache)) {
        return false
      }
          
      //
      const _cached = cache.data.filter( (d: { id: any}) => data.map(x =>x.id).includes(d.id) )

      if(_cached.length > 0) {
        //
        return true
      }
      
      return false
      
    };
    setMuted = (muted: string) => {
      localStorage.setItem('muted', muted)
    };
    getToken = () => {
        return this.store.getItem('token')
    };
    getRefreshToken() {
        return this.store.getItem('refreshToken')
    };
    getUser = () => {
        // return this.store.getItem('user') !== "undefined" ? JSON.parse(this.store.getItem('user') || '{}') : '{}'
        return this.store.getItem('user') ? ( this.store.getItem('user') !== "undefined" ? JSON.parse(this.store.getItem('user') || '{}') : '{}' ) : '{}'
    };
    getVendor = () => {
      return this.store.getItem('vendors') !== "undefined" ? JSON.parse(this.store.getItem('vendors') || '[]') : '[]'
    };
    getPostCache = () => {
      return this.store.getItem('post') !== "undefined" ? JSON.parse(this.store.getItem('post') || '{}') : JSON.parse('{}')
    };
    getStoryCache = () => {
      return this.store.getItem('story') !== "undefined" ? JSON.parse(this.store.getItem('story') || '{}') : JSON.parse('{}')
    };
    getMuted = () => {
        return this.store.getItem('muted')
    };
  }

  // init new auth service,
  const _auth = new AuthService()

  // token & refresh Token
  if (_auth) {
    // axios interceptor - add bearer token
    _auth.api.interceptors.request.use(
      (config) => {
        const token = _auth.getToken();
        //
        if (token) {
          config.headers["Authorization"] = 'Bearer ' + token;  // Node.js Express back-end
        }

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // axios interceptor - req refresh token
    _auth.api.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        const originalConfig = err.config;

        // check for Auth
        if (!["/auth/login", "/auth/register"].includes(originalConfig.url) && err.response) {
          // Access Token was expired
          if (err.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;
    
            try {
              // init refresh token request
              const res = await _auth.refreshToken()
    
              const { token } = res.data;
              _auth.setToken(token);
    
              return _auth.api(originalConfig);

            } catch (_error) {
              return Promise.reject(_error);
            }
          }
        }
    
        return Promise.reject(err);
      }
    );
  }

  export default _auth